import React from 'react';
import { Paragraph, Title, Text } from '@common/components';

export function TermsAndConditionsBody() {
  // https://docs.google.com/document/d/1cneCvlBLwuea0AcJ76PsQRkKUoQ-dJXa/edit

  return (
    <>
      <Title size="h4" weight="bold" center>
        WORKS ONLINE VENDOR AGREEMENT
      </Title>
      <div style={{ marginTop: 24 }} />
      <Paragraph>
        THIS WORKS VENDOR AGREEMENT GOVERNS VENDOR&rsquo;S USE OF TRUSTED
        SERVICES. CAPITALIZED TERMS HAVE THE DEFINITIONS SET FORTH HEREIN.
      </Paragraph>
      <Paragraph>
        BY (1) CLICKING A BOX INDICATING ACCEPTANCE, VENDOR ACCEPTS THIS
        AGREEMENT AND AGREES TO ITS TERMS. IF THE INDIVIDUAL ACCEPTING THIS
        AGREEMENT IS ACCEPTING ON BEHALF OF A COMPANY OR OTHER LEGAL ENTITY,
        SUCH INDIVIDUAL REPRESENTS THAT THEY HAVE THE AUTHORITY TO BIND THE
        ENTITY AND ITS AFFILIATES TO THIS AGREEMENT, IN WHICH CASE THE TERM
        “VENDOR” SHALL REFER TO THE ENTITY AND ITS AFFILIATES.
      </Paragraph>
      <Paragraph>
        IN THE EVENT THAT VENDOR HAS ENTERED TO ANOTHER AGREEMENT WITH TRUSTED
        REGARDING THE SERVICE, INCLUDING, BUT NOT LIMITED TO, A MASTER SERVICES
        AGREEMENT, PLATFORM AGREEMENT, STATEMENT OF WORK AND/OR WORK ORDER
        (“OTHER AGREEMENT”) THE TERMS OF SUCH OTHER AGREEMENT SHALL CONTROL IN
        THE EVENT OF ANY CONFLICT, INCONSISTENCY OR AMBIGUITY BETWEEN THE OTHER
        AGREEMENT&rsquo;S TERMS AND THE TERMS OF THIS AGREEMENT.
      </Paragraph>
      <Paragraph>
        This Agreement was last updated on November 8, 2024. It is effective
        between Vendor and Trusted as of the date of Vendor&rsquo;s accepting
        this Agreement (the “Effective Date”).
      </Paragraph>
      <Paragraph size="lg" weight="bold">
        1. Definitions
      </Paragraph>
      <Paragraph>
        &ldquo;<u>Affiliate</u>
        &rdquo;&nbsp;means any entity that Controls, is Controlled by, or is
        under common Control with the Vendor entity agreeing to these terms,
        where “Control” means ownership of more than 50% of the voting interests
        of the Vendor entity or having the power to direct or cause the
        direction of the management and policies of the entity, whether through
        ownership, by contract, or otherwise.
      </Paragraph>
      <Paragraph>
        &ldquo;<u>Agreement</u>&rdquo; means this Works Vendor Agreement.
      </Paragraph>
      <Paragraph>
        &ldquo;<u>Documentation</u>
        &rdquo;&nbsp;means Trusted&rsquo;s user guides, as updated from time to
        time.
      </Paragraph>
      <Paragraph>
        &ldquo;<u>Personnel</u>
        &rdquo;&nbsp;means any Vendor employees, agents, or representatives that
        Vendor may use to provide staffing services via the Service.
      </Paragraph>
      <Paragraph>
        &ldquo;<u>Service</u>
        &rdquo; means Trusted&rsquo;s Works platform.
      </Paragraph>
      <Paragraph>
        &ldquo;<u>Trusted</u>&rdquo; means Trusted Technologies, Inc.
      </Paragraph>
      <Paragraph>
        &ldquo;<u>User</u>
        &rdquo;&nbsp;means any individual who is authorized by Vendor to use the
        Service under Vendor&rsquo;s account, including Vendor&rsquo;s or its
        Affiliates&rsquo; employees, consultants, contractors, or agents.
      </Paragraph>
      <Paragraph>
        &ldquo;<u>Vendor</u>
        &rdquo;&nbsp;means in the case of an individual accepting this Agreement
        on behalf of a company or other legal entity, the company or other legal
        entity for which such individual is accepting this Agreement.
      </Paragraph>
      <Paragraph>
        &ldquo;<u>Vendor Data</u>
        &rdquo;&nbsp;means all information that Vendor or its Users submit to
        the Service.
      </Paragraph>
      <Paragraph size="lg" weight="bold">
        2. The Service
      </Paragraph>
      <Paragraph>
        <Text weight="bold">2.1&nbsp;Access Rights</Text>.&nbsp;Trusted grants
        Vendor a revocable, temporary, non-exclusive, non-sublicensable,
        non-transferable (except as specifically permitted in Section 11.4)
        right to access and use (and to grant access and use of the Service to
        its Users) the Service in accordance with this Agreement.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">2.2 Acceptable Use Terms.</Text>&nbsp;Vendor will
        not (a) make the Service available to anyone other than Vendor and its
        Users or use the Service for the benefit of anyone other than Vendor or
        its Affiliates; (b) rent, sublicense, re-sell, assign, distribute, time
        share or similarly exploit the Service (including allowing its Users to
        access the Service as guests); (c) reverse engineer, copy, modify,
        adapt, or hack the Service; (d) access the Service, the Documentation,
        or Trusted&rsquo;s Confidential Information to develop a product or
        service in competition with the Service; (e) allow User Subscriptions to
        be shared or used by more than one individual User (except that User
        Subscriptions may be reassigned to new Users replacing individuals who
        no longer use the Service for any purpose); (f) use the Service to
        violate any applicable law, any third party&rsquo;s intellectual
        property rights, or anyone&rsquo;s right of privacy or publicity; (g) or
        use the Service to create, use, send, store, or run viruses, bots,
        worms, or similar harmful material. Upon notice from Trusted, Vendor
        must suspend the account of any User who: (a) violates this Agreement;
        or (b) is using the Service in a manner that Trusted reasonably believes
        may cause a security risk or a disruption to others&rsquo; use of the
        Service. If Vendor fails to promptly suspend or terminate such
        User&rsquo;s account, Trusted reserves the right to do so.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">2.3 Administration of Vendor&rsquo;s Account.</Text>
        &nbsp;Vendor acknowledges that it retains administrative control over to
        whom it grants access to Vendor Data hosted in the Service. Vendor is
        responsible for use of the Service by its Users and for their compliance
        with this Agreement. Vendor is solely responsible for the accuracy,
        quality, and legality of Vendor Data. Vendor will promptly notify
        Trusted if it becomes aware of any unauthorized use or access to
        Vendor&rsquo;s account or the Service.
      </Paragraph>
      <Paragraph size="lg" weight="bold">
        3. Representations and Warranties
      </Paragraph>
      <Paragraph>
        <Text weight="bold">3.1 Mutual Warranties.</Text>&nbsp;Each party
        represents and warrants that it will comply with all laws, rules, and
        regulations applicable to the exercise of its rights and performance of
        its obligations under this Agreement.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">3.2 By Vendor.</Text>&nbsp;Vendor represents and
        warrants that it is entitled to transfer the Vendor Data to Trusted so
        that Trusted and its authorized third-party service providers may
        lawfully use, process, and transfer the Vendor Data in accordance with
        this Agreement on Vendor&rsquo;s behalf.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">3.3 Disclaimer.</Text>&nbsp;THE WARRANTIES SET FORTH
        IN THIS SECTION 3 ARE THE EXCLUSIVE WARRANTIES FROM TRUSTED AND, TO THE
        FULLEST EXTENT PERMITTED BY APPLICABLE LAW, TRUSTED DOES NOT MAKE ANY
        ADDITIONAL WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY,
        OR OTHERWISE, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
        PARTICULAR USE, NONINFRINGEMENT, OR ERROR-FREE OR UNINTERRUPTED USE OF
        THE SERVICE OR PROFESSIONAL SERVICES. EACH PARTY ACKNOWLEDGES AND AGREES
        THAT THE PROVISIONS OF THIS AGREEMENT REFLECT AN ALLOCATION OF RISK
        BETWEEN THE PARTIES THAT IS A MATERIAL INDUCEMENT FOR THE PARTIES
        PERFORMING UNDER THIS AGREEMENT AND THAT THESE DISCLAIMERS AND
        LIMITATIONS ARE FAIR AND REASONABLE UNDER THE CIRCUMSTANCES, AND EACH
        PARTY HEREBY IRREVOCABLY AND PERPETUALLY WAIVES ANY CLAIMS OR CAUSES OF
        ACTION TO THE CONTRARY.
      </Paragraph>
      <Paragraph size="lg" weight="bold">
        4. Term and Termination
      </Paragraph>
      <Paragraph>
        <Text weight="bold">4.1 Term.</Text>&nbsp;This Agreement commences on
        the Effective Date and will remain in effect for as long as Vendor
        continues to use the Service, unless it is terminated earlier in
        accordance with its terms.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">4.2 Termination.</Text>&nbsp;Either party may
        terminate this Agreement: (a) upon thirty (30) days written notice if
        the other party is in material breach of this Agreement and fails to
        cure such breach within the notice period, (b) with immediate effect
        upon receipt of notice in the event of a breach of Section 2.2
        (Acceptable Use Terms); or (c) with immediate effect if the other party
        ceases its business operations or becomes subject to insolvency
        proceedings and the proceedings are not dismissed within sixty (60)
        days.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">4.3 Effect of Termination.</Text>&nbsp;Upon
        termination of this Agreement for any reason, all rights granted to
        Vendor will immediately terminate, and Vendor will immediately cease to
        use the Service. Any terms that by their nature extend beyond the
        Agreement termination remain in effect until fulfilled and apply to
        successors and assignees.
      </Paragraph>
      <Paragraph size="lg" weight="bold">
        5. Confidentiality
      </Paragraph>
      <Paragraph>
        <Text weight="bold">5.1 Definition of Confidential Information.</Text>
        &nbsp;During the course of performance under this Agreement, each party
        may make available to the other party information that is identified as,
        or should reasonably be understood by the receiving party to be,
        proprietary or confidential (the “Confidential Information”).
        Confidential Information specifically includes this Agreement, the
        Service, Vendor Data, business plans, product plans and roadmaps,
        strategies, forecasts, projects and analyses, financial information and
        fee structures, business processes, methods and models, and technical
        documentation. Confidential Information does not include information
        that is: (a) publicly available when received, or subsequently becomes
        publicly available through no fault of the receiving party; (b) obtained
        by receiving party from a source other than the disclosing party without
        obligation of confidentiality; (c) developed independently by the
        receiving party; or (d) already in the possession of the receiving party
        without obligation of confidentiality.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">5.2 Protection of Confidential Information.</Text>
        &nbsp;The receiving party will use the same care and discretion to avoid
        disclosure, publication, or dissemination of the disclosing
        party&rsquo;s Confidential Information as it uses with its own similar
        information that it does not wish to disclose, publish or disseminate,
        but in no event less than a reasonable degree of care. The receiving
        party may disclose Confidential Information to its employees,
        Affiliates, consultants, subcontractors, or advisors who have a need to
        know such Confidential Information for the purpose of performing under
        this Agreement and only to those who are obligated to maintain the
        confidentiality of such Confidential Information upon terms at least as
        protective as those contained in this Agreement. If the parties entered
        into a non-disclosure agreement prior to executing this Agreement, the
        terms of this Section 5 (Confidentiality) will control in the event of
        any conflict or inconsistency.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">5.3 Equitable Relief.</Text>&nbsp;In the event of a
        breach of this Section 5 (Confidentiality), the disclosing party may
        seek appropriate equitable relief in addition to any other remedy.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">5.4 Compelled Disclosure.</Text>&nbsp;The receiving
        party may disclose Confidential Information to the extent required by
        law or court order. However, subject to applicable law, the receiving
        party will give the disclosing party prompt notice to allow the
        disclosing party a reasonable opportunity to obtain a protective order.
      </Paragraph>
      <Paragraph size="lg" weight="bold">
        6. Intellectual Property Rights
      </Paragraph>
      <Paragraph>
        <Text weight="bold">6.1 Trusted Ownership.</Text>&nbsp;As between the
        parties, Trusted exclusively owns all right, title, and interest in and
        to all intellectual property rights in the Service. Vendor&rsquo;s use
        of the Service will not affect Trusted&rsquo;s ownership or license
        rights in the Service. Except for the rights expressly granted in
        Section 2.1, Trusted reserves all rights in the Service and does not
        grant Vendor or its Users any intellectual property rights to the
        Service, including any enhancements, modifications or derivatives
        thereof.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">6.2 Vendor Ownership.</Text>&nbsp;As between the
        parties, Vendor and its licensors will retain all right, title, and
        interest in and to all intellectual property rights in Vendor Data.
        Vendor grants to Trusted a royalty-free, fully paid, non-exclusive,
        non-transferrable (except under Section 11.4), worldwide, right to use
        Vendor Data solely to provide and support the Service. Trusted and its
        authorized third-party service providers may use, host, store, backup,
        transmit, and display Vendor Data to (a) provide the Service and
        Professional Services under this Agreement and (b) improve the Service
        as long as neither Vendor nor its Users are publicly identified.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">6.3 Feedback.</Text>&nbsp;If Vendor submits any
        feedback to Trusted regarding the Service, Trusted may use such feedback
        for any purpose without any compensation or obligation to Vendor
        provided such use does not violate Section 5 (Confidentiality).
      </Paragraph>
      <Paragraph size="lg" weight="bold">
        7. Indemnification
      </Paragraph>
      <Paragraph>
        <Text weight="bold">7.1</Text>&nbsp;If a third party asserts a claim
        against Vendor that the Service as acquired under the Agreement
        infringes a patent or copyright (&ldquo;<u>IP Claim</u>&rdquo;), Trusted
        will (a) defend Vendor against that claim and (b) pay amounts finally
        awarded by a court against Vendor or included in a settlement approved
        by Trusted. To obtain such defense and payment by Trusted, Vendor must
        promptly (i) notify Trusted in writing of the claim, (ii) supply
        information requested by Trusted, and (iii) allow Trusted to control,
        and reasonably cooperate in, the defense and settlement, including
        mitigation efforts.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">7.2</Text>&nbsp;In connection with any IP Claim,
        Trusted may: (1) contest the IP Claim; (2) obtain claimant&rsquo;s
        permission for Vendor&rsquo;s continued use of the applicable Service;
        (3) replace Vendor&rsquo;s access to or use of the applicable Service
        with substantially similar functionality that avoids the IP Claim; or
        (4) if Trusted determines the foregoing clauses (1), (2), and (3) are
        commercially impracticable, terminate Vendor&rsquo;s access to and use
        of the affected Service on 60-days&rsquo; prior notice.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">7.3</Text>&nbsp;Trusted has no responsibility for
        claims based on non-Trusted products and services, items not provided by
        Trusted, or any violation of law or third-party rights caused by Vendor
        Data or other Vendor materials.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">7.4</Text>&nbsp;If a third party asserts a claim
        against Trusted related to (i) Vendor&rsquo;s use of the Services in an
        unlawful manner or in violation of the Agreement or the Documentation,
        (ii) any Vendor Data or Vendor&rsquo;s use of Vendor Data with the
        Services, or (iii) Vendor&rsquo;s failure to pay compensation,
        workers&rsquo; compensation, unemployment compensation, and any all
        state and federal taxes arising out of or related to the employment of
        Vendor&rsquo;s Personnel or failure to provide benefits; from and
        against all costs and expenses for any Vendor Personnel who may receive
        an injury, infectious disease or biohazard exposure, and from any claim,
        suit, or demand related to any credentialing documents, information, or
        data provided by Vendor for or on behalf of its Personnel, Vendor will
        (a) defend Trusted against that claim and (b) pay amounts finally
        awarded by a court against Trusted or included in a settlement approved
        by Vendor. To obtain such defense and payment by Vendor, Trusted must
        promptly (i) notify Vendor in writing of the claim, (ii) supply
        information requested by Vendor, and (iii) allow Vendor to control, and
        reasonably cooperate in, the defense and settlement, including
        mitigation efforts.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">7.5</Text>&nbsp;This Section states each
        party&rsquo;s entire obligation and exclusive remedy regarding the
        third-party claims described in the Section.
      </Paragraph>
      <Paragraph size="lg" weight="bold">
        8. Liability
      </Paragraph>
      <Paragraph>
        <Text weight="bold">8.1</Text>&nbsp;TO THE EXTENT PERMITTED BY LAW, EACH
        PARTY&rsquo;S TOTAL, CUMULATIVE LIABILITY FOR ALL CLAIMS ARISING OUT OF
        OR RELATED TO THE AGREEMENT, WHETHER BASED ON CONTRACT, TORT (INCLUDING
        NEGLIGENCE) OR ANY OTHER LEGAL OR EQUITABLE THEORY, WILL BE LIMITED TO
        $10,000.00 .
      </Paragraph>
      <Paragraph>
        <Text weight="bold">8.2</Text>&nbsp;TO THE EXTENT PERMITTED BY LAW,
        NEITHER PARTY WILL BE LIABLE FOR (A) SPECIAL, INCIDENTAL EXEMPLARY,
        PUNITIVE, INDIRECT, OR ANY CONSEQUENTIAL DAMAGES, OR (B) LOST PROFITS
        (DIRECT OR INDIRECT), FOR LOSS OF USE OR DATA, SERVICE INTERRUPTION
        BUSINESS, VALUE, REVENUE, GOODWILL, OR ANTICIPATED SAVINGS WHETHER BASED
        O CONTRACT, TORT (INCLUDING NEGLIGENCE) OR ANY OTHER LEGAL OR EQUITABLE
        THEORY EVEN IF SUCH PARTY HAS BEEN ADVISED OF SUCH DAMAGES IN ADVANCE OR
        IF SUCH DAMAGES WERE FORESEEABLE.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">8.3</Text>&nbsp;THE FOLLOWING ARE NOT SUBJECT TO THE
        LIMITATION IN SECTION 8.1 AND THE EXCLUSION IN SECTION 8.2: (A) A
        PARTY&rsquo;S INDEMNIFICATION PAYMENTS FOR IP CLAIMS SET FORTH IN
        SECTION 7 (INDEMNIFICATION), AND (B) DAMAGES ARISING FROM A
        PARTY&rsquo;S GROSS NEGLIGENCE, MISCONDUCT, OR FRAUD, SEPARATE AND
        DISTINCT FROM A CAUSE OF ACTION FOR A BREACH OF THIS AGREEMENT.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">8.4</Text>&nbsp;VENDOR ACKNOWLEDGES AND AGREES THAT
        IT IS SOLELY RESPONSIBLE FOR THE PAYMENT OF WAGES, COMPENSATION AND
        RELATED TAXES AND WITHHOLDINGS FOR ANY PERSONNEL THAT IT STAFFS THROUGH
        THE SERVICES. IN NO EVENT WILL TRUSTED BE RESPONSIBLE FOR ANY WAGES,
        COMPENSATION OR TAXES OR WITHHOLDINGS IN CONNECTION WITH VENDOR&rsquo;S
        STAFFING SERVICES.
      </Paragraph>
      <Paragraph size="lg" weight="bold">
        9. PHI
      </Paragraph>
      <Paragraph>
        <Text weight="bold">9.1</Text>&nbsp;Trusted does not provide any
        healthcare services under this Agreement, and Services do not require
        processing of any Protected Health Information (as defined under HIPAA)
        (&ldquo;
        <u>PHI</u>&rdquo;). Therefore, Vendor shall not provide Trusted with any
        PHI. In case the parties need to process PHI under this Agreement, the
        parties agree to execute a business associate agreement.
      </Paragraph>
      <Paragraph size="lg" weight="bold">
        10. Miscellaneous
      </Paragraph>
      <Paragraph>
        <Text weight="bold">10.1 Governing Law; Venue.</Text>&nbsp;Both parties
        agree to (i) the application of the laws of the State of California,
        United States, without regard to conflict of law principles and (ii) the
        exclusive jurisdiction and venue in the state or Federal courts located
        in San Francisco, California.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">10.2 Notices.</Text>&nbsp;Trusted may give general
        notices related to the Service that apply to all Vendors by email,
        in-app notifications, or posting them through the Service. Other notices
        under the Agreement must be in writing and sent to the business mailing
        or email address specified in writing by Vendor. Notices are deemed
        given when received.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">10.3 Relationship of the Parties.</Text>
        &nbsp;Trusted is an independent contractor, not Vendor&rsquo;s agent,
        joint venturer, partner, or fiduciary. No right or cause of action for
        any third party is created by the Agreement or any transaction under it.
        Vendor is solely responsible for its Personnel and is solely responsible
        for the verification of identity and employment eligibility, for the
        payment of any wages, salaries, or other remuneration of its employees,
        agents, representatives, subcontractors, and suppliers, and for the
        payment of any payroll taxes, contributions for unemployment or workers
        compensation, social security, pensions, or annuities that are imposed
        as a result of the employment of Vendor&rsquo;s employees, agents,
        representatives, subcontractors, and suppliers. Vendor must not pledge
        credit, incur any obligation or liability, hire any employee, nor
        purchase any merchandise or services in the name of Trusted or any
        subsidiary or affiliate thereof. All costs, charges, and expenses
        incurred in connection with Vendor&rsquo;s performance of this Agreement
        must be borne by Vendor.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">10.4 Assignment.</Text>&nbsp;Neither party may
        assign the Agreement, in whole or in part, without the prior written
        consent of the other. However, either party may assign the Agreement to
        its Affiliate or to its successor in interest in connection with a
        merger, acquisition, corporate reorganization, or sale of all or
        substantially all of its assets. Notwithstanding the foregoing, if a
        party is acquired by, sells substantially all of its assets to, or
        undergoes a change of control in favor of, a direct competitor of the
        other party, then such other party may terminate this Agreement upon
        written notice. Subject to the foregoing, this Agreement will bind and
        inure to the benefit of the parties, their respective successors and
        permitted assigns.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">10.5 Entire Agreement.</Text>&nbsp;In the event that
        Vendor has not entered into an Other Agreement with Trusted, the terms
        and conditions of this Agreement, including all attachments, exhibits,
        addendums, constitutes the entire agreement between the parties
        concerning the subject matter hereof and supersedes and replaces any
        prior or contemporaneous representations, understandings and agreements,
        whether written or oral, with respect to its subject matter.
        Notwithstanding any language to the contrary therein, no terms or
        conditions stated in a vendor onboarding process and documentation, or
        web portal shall be incorporated into or form any part of this
        Agreement, and all such terms or conditions shall be null and void. To
        the extent that Vendor has entered into an Other Agreement with Trusted,
        the terms of such Other Agreement shall control in the event of any
        conflict, inconsistency or ambiguity between the Other Agreement&rsquo;s
        terms and the terms of this Agreement.
      </Paragraph>
      <Paragraph>
        <Text weight="bold">10.6 Modifications.</Text>&nbsp;Trusted may revise
        this Agreement from time to time by posting the modified version on its
        website. By continuing to access or use the Service after the posted
        effective date of modifications to this Agreement, Vendor agrees to be
        bound by the revised version of the Agreement. If you have an Other
        Agreement with Trusted on this subject matter, this Agreement will not
        apply to the Vendor.
      </Paragraph>
    </>
  );
}
